import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.ApprovalReminderIconButton`

export default defineMessages({
  tooltipText: {
    id: `${scope}.tooltipText`,
    defaultMessage: 'Send approval reminder',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Send approval reminder',
  },
  reminderSentToastTitle: {
    id: `${scope}.reminderSentToastTitle`,
    defaultMessage: 'Success',
  },
  reminderSendToastMessage: {
    id: `${scope}.reminderSendToastMessage`,
    defaultMessage: 'Reminder sent successfully',
  },
  reminderErrorToastTitle: {
    id: `${scope}.reminderErrorToastTitle`,
    defaultMessage: 'Error',
  },
  reminderErrorToastMessage: {
    id: `${scope}.reminderErrorToastMessage`,
    defaultMessage: 'Reminder failed',
  },
  modelTitle: {
    id: `${scope}.modelTitle`,
    defaultMessage: 'Expense',
  },
})
